import { render, staticRenderFns } from "./MaterialeInformativo.vue?vue&type=template&id=948615a0&"
import script from "./MaterialeInformativo.vue?vue&type=script&lang=js&"
export * from "./MaterialeInformativo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports